import { getEffectiveParentId } from '../Sidebar/utils/orphanDetection';

const isTemplateItem = (item) => item?.isTemplate === true || item?.type === 'template';

export function isAtlasCampaign(sprint) {
  return Boolean(
    sprint &&
    !sprint.deletedAt &&
    sprint.status === 'active' &&
    !isTemplateItem(sprint)
  );
}

function sortSiblings(a, b, parent, sprintOrder) {
  const order = parent?.childOrder?.length ? parent.childOrder : sprintOrder;
  if (Array.isArray(order) && order.length > 0) {
    const ai = order.indexOf(a.id);
    const bi = order.indexOf(b.id);
    if (ai !== -1 && bi !== -1) return ai - bi;
    if (ai !== -1) return -1;
    if (bi !== -1) return 1;
  }
  if (a.createdAt && b.createdAt) {
    return new Date(b.createdAt) - new Date(a.createdAt);
  }
  return 0;
}

/**
 * Active campaigns as Atlas tree items. Templates and trash stay off the map.
 * A campaign whose parent is missing or not on the map lands at the root.
 */
export function buildCampaignAtlasItems(sprints = [], sprintOrder = []) {
  const list = Array.isArray(sprints) ? sprints : [];
  const active = list.filter(isAtlasCampaign);
  const activeIds = new Set(active.map((s) => s.id));
  const byId = new Map(list.map((s) => [s.id, s]));

  const items = active.map((s) => {
    const parentId = getEffectiveParentId(s, list);
    return {
      id: s.id,
      name: s.name || 'Untitled',
      parentId: parentId && activeIds.has(parentId) ? parentId : null,
      icon: s.icon || null,
      createdAt: s.createdAt,
      sprint: s,
      kind: 'campaign',
    };
  });

  const byParent = new Map();
  for (const item of items) {
    const pid = item.parentId;
    if (!byParent.has(pid)) byParent.set(pid, []);
    byParent.get(pid).push(item);
  }

  const flatten = (parentId) => {
    const kids = byParent.get(parentId) || [];
    const parent = parentId ? byId.get(parentId) : null;
    kids.sort((a, b) => sortSiblings(a, b, parent, sprintOrder));
    const out = [];
    for (const k of kids) {
      k.docCount = (byParent.get(k.id) || []).length;
      out.push(k);
      out.push(...flatten(k.id));
    }
    return out;
  };

  return flatten(null);
}
